import { BaseButton, Props } from './BaseButton';

export const TransparentButton = (props: Props) => {
  return (
    <BaseButton
      {...props}
      className="text-slate-200 hover:bg-slate-700/80 rounded-lg focus-visible:outline-indigo-600"
    />
  );
};
